export class Base64Helper {
  encode (data) {
    return btoa(JSON.stringify(data))
  }

  decode (base64) {
    return atob(base64)
  }
}
